import { render } from "./modelBind.vue?vue&type=template&id=13926c50&scoped=true"
import script from "./modelBind.vue?vue&type=script&lang=js"
export * from "./modelBind.vue?vue&type=script&lang=js"

import "./modelBind.vue?vue&type=style&index=0&id=13926c50&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13926c50"]])

export default __exports__